import { NotificationContainer, PushNotificationModal, AppUpdateModal } from "@nusrif/ui/client";
import { usePushNotification, useAppUpdate } from "@nusrif/hooks";
import { useNotification } from "@nusrif/contexts";
import { setNotificationHandler, setTokenRegistrationHandler } from "./services/push-messaging";
import { useEffect } from "react";

function App() {
  const { 
    showPermissionModal, 
    setShowPermissionModal, 
    requestPermission,
    sendTokenToBackend
  } = usePushNotification();
  
  const { showNotification } = useNotification();

  const {
    showUpdateModal,
    updateInfo,
    handleUpdate,
    handleCloseModal,
  } = useAppUpdate();

  // Set up the notification handler for push notifications
  useEffect(() => {
    setNotificationHandler(showNotification);
  }, [showNotification]);

  // Set up the token registration handler for token refresh events
  useEffect(() => {
    if (sendTokenToBackend) {
      setTokenRegistrationHandler(sendTokenToBackend);
    }
  }, [sendTokenToBackend]);

  return (
    <>
      <NotificationContainer />
      <PushNotificationModal
        isOpen={showPermissionModal}
        onClose={() => setShowPermissionModal(false)}
        onRequestPermission={requestPermission}
      />
      {updateInfo && (
        <AppUpdateModal
          isOpen={showUpdateModal}
          onClose={handleCloseModal}
          updateInfo={updateInfo}
          onUpdate={handleUpdate}
          isForceUpdate={updateInfo.isForceUpdate || updateInfo.forceUpdate}
        />
      )}
      
      
    </>
  );
}

export default App;
